class SeedPlantingCalculator extends HTMLElement {
  constructor() {
    super();
    this.buttons = this.querySelectorAll('[data-calculate]');
    this.monthInputs = Array.from(this.querySelectorAll('[data-seed-month]'));
    this.dayInputs = Array.from(this.querySelectorAll('[data-seed-day]'));
    this.months = [
      'Jan.',
      'Feb.',
      'Mar.',
      'Apr.',
      'May',
      'June',
      'July',
      'Aug.',
      'Sept.',
      'Oct.',
      'Nov.',
      'Dec.'
    ];

    if (!this.buttons.length) return;

    for (var x = 0; x < this.buttons.length; x++) {
      this.buttons[x].addEventListener('click', (e) => {
        const type = e.target.getAttribute('data-calculate');
        this.populateDates(type);
      });
    }
  }

  populateDates = (type) => {
    if (!type) return;
    const monthInput = this.monthInputs.find((input) => {
      return input.getAttribute('data-seed-month') == type;
    });
    const dayInput = this.dayInputs.find((input) => {
      return input.getAttribute('data-seed-day') == type;
    });
    if (!monthInput || !dayInput) return;
    const month = monthInput.value;
    const day = dayInput.value;
    if (!month || !day) return;

    const columns = this.querySelectorAll(`.${type}-date`);
    if (!columns.length) return;

    for (var x = 0; x < columns.length; x++) {
      const date1 = new Date(month + '/' + day + '/2019');
      const date2 = new Date(month + '/' + day + '/2019');
      const week1 = parseInt(columns[x].getAttribute('data-weekone'), 10) * 7;
      const week2 = parseInt(columns[x].getAttribute('data-weektwo'), 10) * 7;
      date1.setDate(date1.getDate() + week1);
      date2.setDate(date2.getDate() + week2);
      const textDate1 = `${this.months[date1.getMonth()]} ${date1.getDate()}`;
      const textDate2 = `${this.months[date2.getMonth()]} ${date2.getDate()}`;

      if (date1.getTime() > date2.getTime()) {
        columns[x].textContent = `${textDate2} - ${textDate1}`;
      } else {
        columns[x].textContent = `${textDate1} - ${textDate2}`;
      }

      const icon = columns[x].parentElement.querySelector('.icon');
      if (icon) icon.classList.add('visible');
    }
  };
}

customElements.define('seed-planting-calculator', SeedPlantingCalculator);
